import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
// Routes
import apps from './routes/apps'
import landing from './routes/landing'
import dashboard from './routes/dashboard'
import uiElements from './routes/ui-elements/index'
import pages from './routes/pages'
import chartsMaps from './routes/charts-maps'
import formsTable from './routes/forms-tables'
import others from './routes/others'
import terms from './routes/terms'
import privacy from './routes/privacy'
import about from './routes/aboutus'
import contact from './routes/contact'
import affiliate from './routes/affiliate'
import payments from './routes/payments'
import cancellations from './routes/cancellations'
import claims from './routes/claims'
import products from './routes/products'
import offers from './routes/offers'


Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'landing' } },
    ...apps,
    ...landing,
    ...dashboard,
    ...pages,
    ...chartsMaps,
    ...formsTable,
    ...uiElements,
    ...others,
    ...terms,
    ...privacy,
    ...about,
    ...contact,
    ...affiliate,
    ...payments,
    ...products,
    ...cancellations,
    ...claims,
    ...offers,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, from, next) => {
  const urlAgent = new URLSearchParams(window.location.search).get('agent')
  if (urlAgent && store.state.app.agent !== urlAgent) {
    store.commit('app/UPDATE_AGENT', urlAgent)
  }
  next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  if (localStorage.getItem("checkedProducts") !== null) {
    localStorage.removeItem("checkedProducts");
  }
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

router.onError(err => {
  if (err.name !== 'NavigationDuplicated') {
    console.error('Router error:', err);
  }
});

export default router
